import * as React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthProvider';
import axios from '../api/axios';
import { useEffect } from 'react';


export default function Form(){
    const userRef = React.useRef();
    const errorRef = React.useRef();
    const {setAuth} = React.useContext(AuthContext);
    const navigate = useNavigate(); 
    const [isPasswordVisible, setIsPasswordVisible] = React.useState(false);
    const togglePasswordVisibility = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };
    const [user, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    useEffect(() => {
        userRef.current.focus();
    }, []);
    useEffect(() => {
        setError(null);
    }, [user, password]);

    const handleLogin = async (event) => { 
        event.preventDefault();
        const payload = { email: user, password }; 
        try {
            const response = await axios.post('/login', payload, {
                withCredentials: true,
                headers: {
                    'Accept': 'application/json',
                },
            })
            const res_email = response?.data?.email;
            const res_token = response?.data?.token;
            const refreshToken = response?.data?.refresh_token;
            setAuth({res_email, res_token, refreshToken});
            navigate('/home');
            
        } catch (error) { 
            if (!error?.response) {
                setError("No Response from the server");
            } else if (error.response?.status === 400) {
                setError("Invalid Credentials");
            }  else if (error.response?.status === 401) {
                setError("Unauthorized");
            } else {
                setError("Login Failed");
            }
            errorRef.current.focus();
        }
    };

    return (
        <section>
            <p ref={errorRef}>
            {error && <p className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
            <strong className="font-bold">Error!</strong>
            <span className="block sm:inline">{error}.</span>
            <span className="absolute top-0 bottom-0 right-0 px-4 py-3">
                <svg className="fill-current h-6 w-6 text-red-500" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/></svg>
            </span>
        </p>}</p>
        <form onSubmit={handleLogin}>
        <div className='w-full max-w-md p-10 bg-white rounded-2xl shadow-lg'>
            <h1 className='text-5xl font-semibold'>Welcome Back</h1>
            <p className='font-medium text-lg text-gray-500 mt-4'>Welcome back! Please enter your details.</p>
            <div className='mt-8'>
                <div>
                    <label className='text-lg font-medium'>Email</label>
                    <input
                        className='w-full border-2 border-gray-200 rounded-xl p-4 mt-1 bg-transparent'
                        placeholder='Enter your email'
                        value={user}
                        ref={userRef}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label className='text-lg font-medium'>Password</label>
                    <div className='relative'>
                        <input
                            className='w-full border-2 border-gray-200 rounded-xl p-4 mt-1 bg-transparent'
                            placeholder='Enter your password'
                            type={isPasswordVisible ? "text" : "password"}
                            value={password} 
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <button 
                            type="button"
                            onClick={togglePasswordVisibility}
                            className="absolute inset-y-0 end-0 flex items-center z-20 px-3 cursor-pointer text-gray-400 rounded-e-md focus:outline-none focus:text-blue-600 dark:text-neutral-600 dark:focus:text-blue-500">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path className="hs-password-active:hidden" d="M9.88 9.88a3 3 0 1 0 4.24 4.24"></path>
                                <path className="hs-password-active:hidden" d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"></path>
                                <path className="hs-password-active:hidden" d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"></path>
                                <line className="hs-password-active:hidden" x1="2" x2="22" y1="2" y2="22"></line>
                                <path className="hidden hs-password-active:block" d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                                <circle className="hidden hs-password-active:block" cx="12" cy="12" r="3"></circle>
                            </svg>
                        </button>
                    </div>
                </div>
                <div className='flex items-center justify-between mt-4'>
                    <div>
                        <input
                            className='h-4 w-4'
                            type="checkbox"
                            id="remember"
                        />
                        <label className="ml-2 font-medium text-base" htmlFor="remember">Remember me for 30 days</label>
                    </div>
                    <button className='font-medium text-base text-violet-400'>Forgot Password</button>
                </div>
                <div className='mt-6'>
                    <button type='submit' className='active:scale-[.98] active:duration-75 hover:scale-[1.01] ease-in-out transition-all w-full bg-violet-400 text-white rounded-xl p-4'>
                        Login</button>
                    <button className='flex items-center justify-center gap-2 active:scale-[.98] active:duration-75 hover:scale-[1.01] ease-in-out transition-all w-full bg-gray-200 text-gray-500 rounded-xl p-4 mt-4'>
                    <svg width="24" height="24" viewBox="-3 0 262 262" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
                        <path d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027" fill="#4285F4"/>
                        <path d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1" fill="#34A853"/>
                        <path d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782" fill="#FBBC05"/>
                        <path d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251" fill="#EB4335"/>
                    </svg>
                    Login with Google</button>
                </div>
                <div className='flex items-center justify-center mt-6'>
                    <p className='font-medium text-base'>Don't have an account?</p>
                    <a href='/signup' className='font-medium text-violet-400 ml-2'>Sign Up</a>
                </div>
            </div>
        </div>
        </form>
        </section>
    )
}